<template>
    <div class="regicall-announcements">

        <!-- Unread items -->
        <div v-if="unreadItems">
          <AnnouncementsItem v-for="item in unreadItems" 
                            v-bind:key="item.id" 
                            v-bind:announcement="item" 
                            v-bind:onClick="hideItem"/>
        </div>

        <!-- Read items -->
        <div v-if="readItems.length > 0">

            <!-- If collapsed -->
            <div v-if="!showRead">
              <b-button icon-left="bullhorn" type="is-text" @click="showRead = true">Toon {{readItems.length}} gelezen bericht{{ readItems.length > 1 ? 'en' : null }}</b-button>
            </div>

            <!-- If expanded -->
            <div v-else>
              <b-button icon-left="times" type="is-text" @click="showRead = false">Sluit gelezen berichten</b-button>
              <AnnouncementsItem v-for="item in readItems" 
                            v-bind:key="item.id" 
                            v-bind:announcement="item"/>
            </div>

        </div>
    </div>
</template>

<script>
  import Cookie from 'js-cookie';

  import AnnouncementsItem from './AnnouncementsItem';

  const cookieName = 'read_announcements';

  export default {
    components: {
      AnnouncementsItem
    },
    props: {
      items: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        read: this.getCookie(),
        showRead: false
      };
    },
    computed: {
      unreadItems () {
        return this.items.filter((item) => !this.read.includes(item.id));
      },
      readItems () {
        return this.items.filter((item) => this.read.includes(item.id));
      }
    },
    methods: {
      hideItem (item) {
        this.read.push(item.id);
        this.setCookie(this.read);
      },
      setCookie (object) {
        Cookie.set(cookieName, object);
      },
      getCookie () {
        return Cookie.getJSON(cookieName) || [];
      }
    }
  };
</script>

<style lang="scss" scoped>
  .regicall-announcements {
    margin-bottom: 1.6em;
  }
  .button.is-text {
    opacity: 0.9;
    margin-top: 0.25rem;
    &:hover,&:active,&:focus {
      background-color: transparent;
      opacity: 1;
    }
    &::v-deep .icon {
      text-decoration:none;
      display:inline-block;
    }
  }
</style>
